<ng-template let-item>
    <div (click)="$event.stopPropagation()">
        <app-dot-menu
          *ngIf="isEnabledPredicate ? isEnabledPredicate(item) : true"
          [menuItems]="menuConfig"
          (clicked)="onMenuClick($event, item)">
        </app-dot-menu>
    </div>
</ng-template>
